import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

@Component({
  selector: 'fgb-photo-scramble-layout-page',
  templateUrl: './photo-scramble-layout-page.component.html',
  styleUrl: './photo-scramble-layout-page.component.scss',
})
export class PhotoScrambleLayoutPageComponent implements OnInit {
  private translate = inject(TranslateService);
  private featureFlagKey = 'feature.flag.photo.scramble.leaderboard';
  private destroyRef = inject(DestroyRef);
  isLeaderboardEnabled: boolean = false;

  ngOnInit(): void {
    this.translate
      .stream(this.featureFlagKey)
      .pipe(
        map((translation) => translation.toLocaleLowerCase() === 'true'),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((isEnabled) => {
        this.isLeaderboardEnabled = isEnabled;
      });
  }
}
